
import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
import { addOpenLeads } from "@/apis/home";
@Component({
  components: {}
})
export default class ApplySuccessDialog extends Vue {
  @PropSync("show") dialogVisible!: boolean;
  @Prop({ required: true }) private status!: any;
  @Prop({ required: false }) private appendToBody: any;
  formatUpyunUrl = formatUpyunUrl;
  form = {
    name: "",
    job: "",
    open_name: "",
    revenue: "",
    tel: "",
    cust_remark: ""
  };

  handleClose() {
    this.dialogVisible = false;
    this.$emit("close");
  }
}
